import React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { Button, createTheme } from '@mui/material';
import { ThemeProvider } from '@emotion/react';


const theme = createTheme({
    palette: {
        appprimary: {
            main: 'rgb(0 74 255 / 70%)',
            light: '#E9DB5D',
            dark: '#A29415',
            contrastText: '#242105',
        },
    },
});

export const MUIButton = (props) => {
    const color = React.useMemo(() => {
        let pallete = '';
        switch (props.color) {
            case 'primary': {
                pallete = 'appprimary';
                break;
            }
        }
        return pallete;
    }, [props.color]);
    return (
        <ThemeProvider theme={theme}>
            <Button
                {...props}
                color={color} onClick={props.onClick}
                startIcon={props.startIcon}
                variant="text"
                endIcon={props.endIcon}
                size={props.size}
               
            >
                {props.text}
            </Button>
        </ThemeProvider>
    )
}


